'use client';

/**
 * Generate Layout Client
 *
 * Client-side wrapper for the generate media page.
 * Uses AppLayoutWrapper for consistent navbar + sidebar styling.
 */
import { AppLayoutWrapper } from '~/_components/app-layout-wrapper';
import { GpuPrewarm } from '~/_components/gpu-prewarm';

export function GenerateLayoutClient({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AppLayoutWrapper showCoinBalance={true}>
      {/* Landing here is the earliest reliable signal a generation is coming. */}
      <GpuPrewarm kind="image" />
      <div className="flex-1 overflow-y-auto bg-gradient-to-br from-[#0a0a0a] via-[#160a2a] to-[#0d001a]">
        {children}
      </div>
    </AppLayoutWrapper>
  );
}
